import styled from 'styled-components';

export const ClickAnywhereElseToCloseCover = styled.div<{ $opaque?: boolean }>`
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 10;
	background-color: ${({ $opaque }) => ($opaque ? 'rgba(0,0,0,0.6)' : 'transparent')};
`;
